/**
 * 2ECOMP - Módulo de Câmeras Veiculares
 *
 * Detecção automática de câmera:
 * - Atributo da posição: videoAlarm (JT1078)
 * - Atributo do dispositivo: hasCamera (manual)
 */

// Jimi Cloud (legado - usado por MainPage.jsx)
const JIMI_API_URL = 'https://jimi-iothub-instruct-api.fleetmap.io/api/device/sendInstruct';
const JIMI_VIDEO_IP = 'jimi-iothub.fleetmap.io';
const JIMI_VIDEO_PORT = '10002';

/**
 * Verifica se um dispositivo tem capacidade de câmera
 *
 * Prioridade:
 * 1. Atributo do dispositivo: hasCamera (configuração manual)
 * 2. Modelo do dispositivo (modelos JT1078 conhecidos)
 * 3. Atributo da posição: videoAlarm (auto-detectado pelo protocolo JT1078)
 */
export const deviceHasCamera = (device, position = null) => {
  if (device?.attributes?.hasCamera === true) {
    return true;
  }
  if (device?.attributes?.hasCamera === false) {
    return false;
  }
  const model = (device?.model || device?.attributes?.form?.model || '').toUpperCase();
  if (/^M[CD](20[2-6]|ETTA)/i.test(model)) {
    return true;
  }
  if (position?.attributes?.videoAlarm !== undefined) {
    return true;
  }
  return false;
};

/**
 * Envia comando JT808 para iniciar streaming via Jimi Cloud
 * @deprecated Use JT1078 com câmeras apontando direto para nosso servidor
 */
export const startStreaming = (imei, proNo = 37121, channel) => sendCommand(
  imei,
  proNo,
  proNo === 37121
    ? {
      dataType: 0,
      codeStreamType: 1,
      channel,
      videoIP: JIMI_VIDEO_IP,
      videoTCPPort: JIMI_VIDEO_PORT,
      videoUDPPort: 0,
    }
    : 'RTMP,ON,INOUT',
);

const sendCommand = (imei, proNo, cmdContent) => {
  const params = new URLSearchParams();
  params.append('deviceImei', imei);
  params.append('imei', imei);
  params.append('proNo', proNo);
  params.append('serverFlagId', '1');
  params.append('cmdType', 'normallns');
  params.append('requestId', '6');
  params.append('platform', 'web');
  params.append('token', 'a12341234123');
  params.append('cmdContent', proNo === 37121 ? JSON.stringify(cmdContent) : cmdContent);
  return fetch(JIMI_API_URL, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    },
    body: params.toString(),
  });
};
